import styled from 'styled-components';
import { TextOPValue } from '../types';

const TextWrap = styled.div`
  font-family: 'Ruda';
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: var(--color-aurora-text-1);
`;

// 文本插件
export const Text = ({ value }: { value: TextOPValue }) => {
  return <TextWrap>{value}</TextWrap>;
};
